/**
 * 백엔드 에러 본문에서 사용자에게 보여줄 문구를 뽑는다.
 * 기관 API 는 `{ error: { code, message } }`(스펙 §4.8), 그 외 Nest 기본 예외는
 * `{ message }` 또는 `{ message: string[] }` 로 온다. 둘 다 받아준다.
 */
export const getApiErrorMessage = (error: unknown, fallback: string): string => {
  const body = (error as { response?: { data?: unknown } } | undefined)?.response?.data;
  if (!body || typeof body !== 'object') return fallback;

  const wrapped = (body as { error?: { code?: string; message?: string } }).error;
  if (wrapped?.message) return wrapped.message;
  if (wrapped?.code) return wrapped.code;

  const message = (body as { message?: unknown }).message;
  if (typeof message === 'string' && message) return message;
  if (Array.isArray(message) && typeof message[0] === 'string') return message[0];

  return fallback;
};

/** 기관 API 에러 코드(§4.8). 화면에서 코드별 안내를 나눌 때 쓴다 */
export const getApiErrorCode = (error: unknown): string | null => {
  const body = (error as { response?: { data?: unknown } } | undefined)?.response?.data;
  if (!body || typeof body !== 'object') return null;
  const code = (body as { error?: { code?: string } }).error?.code;
  return code ?? null;
};
